import { getGroupsFromDataGrid, getPointsWithInfoFromTableGroups } from "@/grid/GridMultiLocationTable/hooks/utils";
import type { LocationGroup } from "@/locationTable/types";
import { WindowKind, instanceId, useDesktop } from "@/overlay/components";
import type { PoiDataGrid } from "@/threads/DataProcessingThread/types";
import { useCallback } from "react";

export const useHandleEditLocations = (
  groups: LocationGroup[],
  onLocationChange: (groups: LocationGroup[]) => void,
) => {
  const desktop = useDesktop();
  const tablePoints = getPointsWithInfoFromTableGroups(groups);

  const openLocationManager = useCallback(() => {
    desktop.dispatch({
      type: "confirmationWindow",
      windowId: instanceId(WindowKind.PoiManagerWindow),
      customProps: {
        onUpdate: (data: PoiDataGrid) => {
          const tableGroups = getGroupsFromDataGrid(data);
          onLocationChange(tableGroups);
        },
        initialData: tablePoints,
      },
    });
  }, [desktop, groups, onLocationChange]);

  return openLocationManager;
};
